"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInput = void 0;
const styled_system_1 = require("styled-system");
const styled_1 = __importDefault(require("../../../styles/styled"));
exports.BaseInput = styled_1.default.input(({ theme }) => ({
    backgroundColor: theme.colors.transparent,
    fontFamily: theme.text.bodyFontFamily,
    color: theme.colors.grey90,
    border: 'none',
    width: '100%',
    /*
     * outline: none is bad practice for a11y, but our inputs are wrapped in
     * other elements that should provide the focus styling. We don't have designs
     * these yet. TODO: Add 'focus' state styling to all inputs
     */
    outline: 'none',
    ':disabled': {
        cursor: 'not-allowed',
    },
}), styled_system_1.color, styled_system_1.border, styled_system_1.space, styled_system_1.typography, styled_system_1.flexbox, styled_system_1.layout);
//# sourceMappingURL=base_input.js.map